
import React from "react";
import { Routes, Route, } from "react-router-dom";  
import { RouteConstant } from "./RouteConstant";
import PageLayout from "../screens/Layout";
import LoginScreen from "../screens/Login/LoginScreen";
import UserList from "../screens/User/UserList";
import HolidayScreen from "../screens/Holiday/HolidayScreen";
import StatusHistory from "../screens/StatusHistory/StatusHistory";

const SuperAdminRoutes = () => {
  return (
    <Routes>
        <Route path={RouteConstant.ROOT} element={<PageLayout />}>
            <Route path={RouteConstant.USERS} element={<UserList />} />
            <Route path={RouteConstant.HOLIDAY} element={<HolidayScreen />} />
            <Route path={RouteConstant.STATUSHISTORY} element={<StatusHistory />} />
        </Route>
    </Routes>
  );
}

export default SuperAdminRoutes;